import React from "react";
import "./style.css";

function Footer() {
  return (
    <footer className="footer">
      <div className="bottom">
        {/* footer content */}
        <img alt="react" src="assets/images/logo.svg"/>
        React, Recall, Rearrange!
        <img alt="react" src="assets/images/logo.svg"/>
      </div>
    </footer>
  );
}

export default Footer;
